module.exports = "<breadcrumbs current-page-name=\"'Client Select'\"> </breadcrumbs> <page-title icon=\"'fa-users'\" title=\"'Facility Reporting - Client Select'\"> </page-title> <report-client-selector button-text=\"'View Report'\" client-list=$ctrl.clientList on-button-click=$ctrl.viewReport(clientList) report-state=\"'app.facility-reporting.facility-reporting-grid'\"> </report-client-selector> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/facility-reporting/client-select/client-select.html
// module id = 384
// module chunks = 0